import { useTranslations } from '@ifixit/i18n/hooks';
import type { FormEvent } from 'react';
import { CodeInput } from './components/CodeInput';
import { useLoginCode } from './hooks/useLoginCode';

interface LoginCodeProps {
   email: string;
   onNavigateBack: () => void;
   onLoginComplete?: () => void;
}

export const LoginCode = ({ email, onNavigateBack, onLoginComplete }: LoginCodeProps) => {
   const t = useTranslations('Login');
   const { code, setCode, isSubmitting, error, submitCode } = useLoginCode({
      email,
      onNavigateBack,
      onLoginComplete,
   });
   const codeInputId = 'login-code-input';

   const handleSubmit = (e: FormEvent) => {
      e.preventDefault();
      void submitCode();
   };

   return (
      <div className="login-code-wrapper flex flex-col gap-6 py-8 px-6 bg-card border-1 rounded-base text-base w-full md:w-[384px]">
         <form onSubmit={handleSubmit} className="w-full">
            <div className="text-center text-gray-600 dark:text-muted-foreground">
               {t('loginCodeSentTo')}
               <span className="font-medium">
                  {email}
                  <button
                     type="button"
                     className="ml-2 text-blue-ifixit hover:underline disabled:opacity-50"
                     onClick={onNavigateBack}
                     disabled={isSubmitting}
                  >
                     ({t('change')})
                  </button>
               </span>
            </div>
            <div className="flex flex-col gap-6 mt-6">
               <div className="w-full">
                  <CodeInput value={code} onChange={setCode} inputId={codeInputId} />
                  {error && <p className="text-red-500 mt-2 text-sm">{error}</p>}
               </div>
               <button
                  type="submit"
                  className="w-full button-primary button-lg"
                  disabled={isSubmitting}
               >
                  {isSubmitting ? t('verifyingCode') : t('logIn')}
               </button>
            </div>
         </form>
      </div>
   );
};
